const advertisingCampaigns = {
  headlines: 'Заголовки',
  headline: 'Заголовок',
  description: 'Описание',
  adsHeadlinesAndDescriptions: 'Заголовки и описания объявлений',
  summary: 'Итог',
  targetCpi: 'Целевой CPI',
  dailyBudget: 'Ежедневный бюджет',
  showHeadlines: 'Показывать заголовки',
  countries: 'Страны',
  duration: 'Длительность',
};

export default advertisingCampaigns;
